import { defineComponent, h } from 'vue';
import { utility } from '@phi/components';

export const Section = defineComponent({
    props: {
        as: {
            required: false,
            type: String,
            default: 'section',
        },

        horizontal: {
            required: false,
            type: Boolean,
            default: false,
        }
    },

    render() {
        return h(this.as, {
            class: {
                [utility.flex]: this.horizontal,
                [utility.gap_3]: this.horizontal,
                [utility.align_baseline]: this.horizontal,
                [utility.margin_gap_3]: !this.horizontal,
            }
        }, [
            this.$slots.header && this.$slots.header(),
            h('div', {
                class: this.horizontal ? utility.flexible : ''
            }, this.$slots.body && this.$slots.body()),
        ]);
    },
});
